import EditCalendarRoundedIcon from '@mui/icons-material/EditCalendarRounded';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const ArchiveButton = () => {
  const { t } = useTranslation();

  return (
    <Link
      to="/archive"
      className="h-10 border rounded-xl w-full bg-slate-600 border-slate-700 hover:bg-slate-500 active:bg-green-700 text-white font-semibold px-2 py-1 text-md flex items-center justify-center text-center whitespace-nowrap"
    >
      <EditCalendarRoundedIcon className="mr-2" fontSize="small" />
      {t('archive.playArchive')}
    </Link>
  );
};
